import {Header, Resume} from "../../Components";


function AboutMe() {
    return (
        <div className='App-content'>
            <Header />
            <div className='App-body'>
                <div className='fourth-left-aligned middle-height top-item'>
                    Future Blog!!
                </div>
            </div>
        </div>
    );
}

export default AboutMe;